module.exports = __webpack_public_path__ + "img/battery_dianchi_icon.84aa345f.png";